module.exports = __webpack_public_path__ + "static/img/009.d348daf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-headquarters/009.png
// module id = kSEc
// module chunks = 1